import axios, { AxiosRequestConfig } from 'axios'
import { isDev } from 'helpers/common'

export const API_SERVER_URL = isDev
  ? 'https://dev-game-api.rampmedaddy.com'
  : 'https://game-api.rampmedaddy.com'
export const BASE_URL = `${API_SERVER_URL}/api`

export const axiosInstance = axios.create()

const TOKEN = isDev
  ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoyMDQ5Nzg3MDcwLCJpYXQiOjE3MzQ0MjcwNzAsImp0aSI6IjllMGNjZjY0NzYyODQ0NmQ5MGUzZjgzMTBhMGJjMzg0IiwidXNlcl9pZCI6Mn0.fDqFN5drUnpbtGCwWOdnUQGA8rwLGI5ogDNqDhCjD-8'
  : 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoyMDUwNTYzODEwLCJpYXQiOjE3MzUyMDM4MTAsImp0aSI6ImRkYmVmMmQzNTg3ZTRmZWI5MzY5ZDA4MTYzZWVhMTJhIiwidXNlcl9pZCI6Mn0.PzrLvoEgBjwGsQ4-eoHpSLq8mNLiXSGs90RwfFrpFTU'

export interface CustomError {
  response: {
    data: {
      error: string
    }
  }
}

export const request = async <T>(config: AxiosRequestConfig): Promise<T> => {
  const resp = await axiosInstance.request(config)

  return resp.data
}

// Request interceptor
axiosInstance.interceptors.request.use((config) => {
  config.headers!['Authorization'] = `Bearer ${TOKEN}`
  return config
})

export default request
